import { render, staticRenderFns } from "./MyPublications.vue?vue&type=template&id=f69519be&scoped=true"
import script from "./MyPublications.vue?vue&type=script&lang=js"
export * from "./MyPublications.vue?vue&type=script&lang=js"
import style0 from "./MyPublications.vue?vue&type=style&index=0&id=f69519be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69519be",
  null
  
)

export default component.exports